<template>
  <div
    :style="{
      '--border-width': `${borderWidth}px`,
      '--duration': `${duration}s`,
      '--shine-color': Array.isArray(shineColor) ? shineColor.join(',') : shineColor
    }"
    class="shine-border"
  ></div>
</template>

<script setup lang="ts">
defineProps({
  /**
   * Width of the border in pixels
   * @default 1
   */
  borderWidth: {
    type: Number,
    default: 1
  },
  /**
   * Duration of the animation in seconds
   * @default 14
   */
  duration: {
    type: Number,
    default: 14
  },
  /**
   * Color of the border, can be a single color or an array of colors
   * @default "#000000"
   */
  shineColor: {
    type: [String, Array],
    default: "#000000"
  }
})
</script>

<style scoped>
.shine-border {
  position: absolute;
  inset: 0;
  height: 100%;
  width: 100%;
  border-radius: inherit;
  padding: var(--border-width);
  pointer-events: none;
  background-image: radial-gradient(circle at center, 
    transparent 0%, 
    var(--shine-color) 50%, 
    transparent 100%
  );
  background-size: 300% 300%;
  background-position: 0% 0%;
  animation: shine var(--duration) linear infinite;
  
  /* Border mask */
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
}

@keyframes shine {
  0% {
    background-position: -100% -100%;
  }
  25% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  75% {
    background-position: 200% 200%;
  }
  100% {
    background-position: -100% -100%;
  }
}
</style> 